module.exports = __webpack_public_path__ + "5-lined-5562adb34b7ebc67fae1e1e1522a0bd7.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/lined/5-lined.svg
// module id = 134
// module chunks = 0